import { BillingMode, InvoiceStatus, InvoiceType } from '../../../../../../services/exports/Constants';

export default {
  title: 'Factures',
  form: {
    title: 'Demander un nouveau paiement',
    company: {
      label: 'Restaurant',
    },
    billing_mode: {
      label: 'Source de facturation',
    },
    billing_anchor: {
      label: 'Début de facturation le',
    },
    items: {
      label: 'Éléments',
    },
    name: {
      label: 'Nom',
      placeholder: '1000x Flyers',
    },
    net_amount: {
      label: 'Montant (HT)',
      tax_breakdown: '+{{tax}} TVA = {{total}}',
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    name: 'Nom/Numéro',
    billing_mode: 'Source de facturation',
    type: 'Type',
    status: 'Statut',
    amount: 'Montant (TTC)',
    created_at: 'Créé',
    billing_anchor: 'Facturation depuis',
    invoice: 'Facture',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Mode de paiement',
    [BillingMode.InternalInvoicing]: 'Ventes',
  },
  types: {
    [InvoiceType.Manual]: 'Manuel',
    [InvoiceType.SetupFee]: "Frais d'installation",
    [InvoiceType.Subscription]: 'Abonnement',
  },
  statuses: {
    [InvoiceStatus.Pending]: 'En attente',
    [InvoiceStatus.Processing]: 'En cours',
    [InvoiceStatus.Paid]: 'Payé',
    [InvoiceStatus.PartiallyRefunded]: 'Partiellement remboursé',
    [InvoiceStatus.Refunded]: 'Remboursé',
    [InvoiceStatus.Failed]: 'Échoué',
  },
  modals: {
    invoice_creation_confirmation: {
      title: 'Voulez-vous vraiment créer une facture de {{amount}} HT pour {{company}} via {{billingMode}} ?',
    },
    invoice_recharge_confirmation: {
      title: 'Êtes-vous sûr ?',
      description:
        "<strong>{{company}}</strong> sera débité de <strong>{{amount}} TTC + pénalité d'échec de paiement si applicable</strong> via le mode de paiement principal pour la facture {{details}}",
      recharge_failed: {
        title: 'Stripe a refusé le paiement',
        convert_hint:
          'Vous pouvez encaisser cette facture sur les ventes du restaurant. La facture Stripe sera annulée et le montant dû sera déduit des prochains virements.',
      },
    },
  },
  buttons: {
    show_transfers: 'Afficher les transferts',
    hide_transfers: 'Masquer les transferts',
    create: 'Créer',
    download_pdf: 'Télécharger PDF',
    open_payment_page: 'Ouvrir la page de paiement',
    open_invoice_page: 'Ouvrir les détails de la facture',
    add_item: 'Ajouter un élément',
    convert_to_internal_billing: 'Encaisser sur les ventes',
    recharge_invoice: 'Relancer la facture',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
    failed_to_create_invoice: 'Échec de la création de la facture !',
    invoice_got_created: 'Facture créée !',
    invoice_got_recharged: 'Facture relancée. Nouveau paiement en cours !',
    failed_to_recharge_invoice: 'Échec de la relance de la facture !',
    invoice_got_converted_to_internal_billing:
      'Facture convertie en facturation sur ventes. Le montant dû sera déduit des prochains virements.',
    failed_to_convert_invoice_to_internal_billing: 'Échec de la conversion en facturation sur ventes !',
  },
};
